(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-help"]) return;
  try {
    
(function () {
  function openZendeskChat() {
    try {
      if (typeof window.zE === 'function') {
        try { window.zE('messenger', 'open'); return; } catch (error) {}
        try { window.zE('webWidget', 'open'); return; } catch (error) {}
        try { window.zE('webWidget', 'chat:send', ''); window.zE('webWidget', 'open'); return; } catch (error) {}
      }
      if (window.$zopim && window.$zopim.livechat && window.$zopim.livechat.window) {
        window.$zopim.livechat.window.show();
        return;
      }
      var launcher = document.querySelector('[aria-label*="chat" i], [class*="zEWidget"], iframe[title*="chat" i], iframe[title*="messag" i]');
      if (launcher && typeof launcher.click === 'function') launcher.click();
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('.comparison-help [data-open-zendesk-chat]');
    if (!trigger) return;
    event.preventDefault();
    openZendeskChat();
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-collection-template"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-deals-read-more]');

    sections.forEach(function (section) {
      var content = section.querySelector('[data-deals-read-more-content]');
      var toggle = section.querySelector('[data-deals-read-more-toggle]');

      if (!content || !toggle) {
        return;
      }

      if (content.scrollHeight <= content.clientHeight + 8) {
        section.classList.add('is-short');
        return;
      }

      toggle.addEventListener('click', function () {
        var expanded = section.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Read Less' : 'Read More';
      });
    });

    document.addEventListener('click', function (event) {
      var launcher = event.target.closest && event.target.closest('[data-deals-chat-launch]');
      if (!launcher) return;

      if (typeof window.zE === 'function') {
        window.zE('webWidget', 'open');
        return;
      }

      var zendeskLauncher = document.querySelector('iframe#launcher');
      if (zendeskLauncher && zendeskLauncher.contentWindow) {
        try {
          zendeskLauncher.contentWindow.focus();
        } catch (error) {}
      }
    });

    function reviewNumberFromText(text) {
      if (!text) return 0;
      var match = text.replace(/,/g, '').match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    function syncDealsReviewCounts() {
      var rows = document.querySelectorAll('[data-deals-review-row]');

      rows.forEach(function (row) {
        var customCount = reviewNumberFromText(row.getAttribute('data-custom-review-count'));
        var yotpoMetafieldCount = reviewNumberFromText(row.getAttribute('data-yotpo-review-count'));
        var yotpoBadge = row.querySelector('.shopify-product-reviews-badge');
        var yotpoCount = reviewNumberFromText(yotpoBadge ? yotpoBadge.textContent : '');
        var total = customCount + Math.max(yotpoMetafieldCount, yotpoCount);
        var totalNode = row.querySelector('[data-deals-total-reviews]');

        if (!totalNode || total <= 0) return;
        totalNode.textContent = total.toLocaleString();
        row.classList.add('has-review-count');
      });
    }

    [250, 750, 1500, 3000, 6000, 10000].forEach(function (delay) {
      window.setTimeout(syncDealsReviewCounts, delay);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-history-timeline"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.mattress-history');
    if (!root) return;

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        var target = id && document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mattress-builder-preflight"]) return;
  try {
    
window.keel = true;

  } catch(e) { console.error(e); }
})();
})();
